import React, { useState } from "react";
import {
  Typography,
  TextField,
  Box,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";
import GradientButton from "../../common/GradiantButton";
import SecondaryButton from "../../common/SecondaryButton";
import { investorApi } from "../../../api/api";

const WithdrawDrawer = ({ walletAmount = 0, userId, onClose, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const validateAmount = (value) => {
    if (!value) return "Please enter an amount";
    if (isNaN(value) || parseFloat(value) <= 0)
      return "Please enter a valid positive number";
    if (parseFloat(value) > walletAmount)
      return "Amount exceeds wallet balance";
    return "";
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setAmount(value);
    setError(validateAmount(value));
  };

  const handleWithdraw = async () => {
    const validationError = validateAmount(amount);
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setSubmitting(true);
      setError("");

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("amount", amount);

      await investorApi.addWithdraw(formData);

      setSuccessMessage(
        `₹ ${parseFloat(amount).toFixed(2)} withdrawal request submitted successfully.`
      );

      setAmount("");

      if (onSuccess) onSuccess();

      setTimeout(() => {
        setSubmitting(false);
        onClose();
      }, 1200);
    } catch (err) {
      setSubmitting(false);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Withdraw Request
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Typography variant="body1" sx={{ mb: 2 }}>
        Available Balance:
        <strong> ₹ {walletAmount.toLocaleString()}</strong>
      </Typography>

      <TextField
        fullWidth
        label="Withdrawal Amount"
        type="number"
        value={amount}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        inputProps={{ min: 0, max: walletAmount, step: "0.01" }}
        sx={{ mb: 3 }}
      />

      {successMessage && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMessage}
        </Alert>
      )}

      {error && !successMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <GradientButton
          text={
            submitting ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              "Withdraw"
            )
          }
          onClick={handleWithdraw}
          disabled={submitting || !amount}
          width="50%"
        />

        <SecondaryButton
          text="Cancel"
          onClick={onClose}
          width="50%"
        />

        
      </Box>
    </>
  );
};

export default WithdrawDrawer;